import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigation } from './navigationConfig';

interface NavigationProps {
  currentPath?: string;
}

const Navigation: React.FC<NavigationProps> = ({ currentPath }) => {
  const location = useLocation();
  const path = currentPath || location.pathname;

  const isActive = (href: string) => {
    if (href === '/') {
      return path === '/';
    }
    return path?.startsWith(href);
  };

  return (
    <nav className='hidden md:block flex-1 mx-8 lg:mx-12'>
      <div className='flex items-center justify-center gap-3 lg:gap-5'>
        {navigation.map(item => (
          <Link
            key={item.name}
            to={item.href}
            className={`px-4 py-3 text-base font-semibold transition-all duration-200 relative rounded-lg ${
              isActive(item.href)
                ? 'text-glory-gold bg-glory-gold/10'
                : 'text-white hover:text-glory-gold-light hover:bg-white/5'
            }`}
          >
            {item.name}

            {/* 激活状态指示条 */}
            {isActive(item.href) && (
              <div className='absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-glory-gold to-glory-gold-light rounded-full shadow-sm' />
            )}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;
